var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14829_10203)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14829_10203",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 30,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1128 4.21143H5.11279V32.2114H34.1128V4.21143Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14829_10203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.11279 11.0621V29.9729C5.11272 30.2651 5.16823 30.5544 5.27614 30.8244C5.38406 31.0944 5.54227 31.3397 5.74174 31.5463C5.9412 31.753 6.17802 31.9169 6.43867 32.0287C6.69931 32.1406 6.97867 32.1981 7.2608 32.1981H13.7861V8.8374H7.2608C6.69111 8.8374 6.14476 9.07179 5.74193 9.489C5.3391 9.90621 5.11279 10.4721 5.11279 11.0621Z",
    fill: "#FFD836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9647 8.83691H25.625V32.1976H31.9647C32.5343 32.1975 33.0805 31.963 33.4832 31.5458C33.8859 31.1286 34.1122 30.5629 34.1122 29.9729V11.0616C34.1122 10.4717 33.8859 9.90591 33.4832 9.48871C33.0805 9.07152 32.5343 8.83706 31.9647 8.83691Z",
    fill: "#FFD836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4623 4.21143H15.9418C15.6596 4.21135 15.3803 4.26884 15.1196 4.38061C14.8589 4.49238 14.6221 4.65623 14.4225 4.86282C14.223 5.06941 14.0648 5.31469 13.9568 5.58464C13.8488 5.85459 13.7932 6.14392 13.7932 6.43612V32.2109H25.6103V6.43612C25.6103 5.8461 25.384 5.28024 24.9811 4.86302C24.5783 4.44581 24.0319 4.21143 23.4623 4.21143ZM23.4623 8.66082H15.9418V7.54818C15.9418 7.25325 16.0549 6.97039 16.2563 6.76184C16.4576 6.55328 16.7307 6.43612 17.0155 6.43612H22.388C22.6728 6.43612 22.946 6.55327 23.1474 6.7618C23.3489 6.97034 23.4621 7.25319 23.4623 7.54818V8.66082Z",
    fill: "#FFB308"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14829_10203"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 28,
    fill: "white",
    transform: "translate(5.11279 4.21143)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusiness);
export default __webpack_public_path__ + "static/media/icon_business.b72d5c4d93c2681dc4c720a93fcd8dae.svg";
export { ForwardRef as ReactComponent };